module.exports = __webpack_public_path__ + "media/ASU_Header_1080p_24fps.77b7c315.mp4";